import React from 'react';

const prawnBorder =
  'https://santaplaya-bucket.s3.amazonaws.com/prawn_border.webp';
const blueCrab = 'https://santaplaya-bucket.s3.amazonaws.com/blueCrab.webp';

const SauceOptions: React.FC = () => (
  <div className="mt-6 border-t border-sea pt-4">
    <p className="font-prosto text-maroon text-sm text-center">
      <strong>Sauce Options:</strong> All items come with your choice of sauce:
      Verde, Roja, Negra (House Sauce).
    </p>
  </div>
);

// Define the items for the cold (Frío) column
const frioItems = [
  { name: 'Aguachiles', price: '$22', description: '' },
  {
    name: 'Tosti-Vichiii',
    price: '$24',
    description: 'Your choice of ceviche over chips.',
  },
  {
    name: 'Camaron Botana',
    price: '$22',
    description: 'Shrimp (Cooked and Crudo).',
  },
  {
    name: 'Camaron y Pulpo Botana',
    price: '$25',
    description:
      'Shrimp and octopus with onion, cucumber, and choice of sauce.',
  },
  {
    name: 'Camaron y Atun Botana',
    price: '$26',
    description:
      'Shrimp and bluefin tuna with onion, cucumber, and choice of sauce.',
  },
  {
    name: 'Santa Playa Botana',
    price: '$34',
    description: 'Shrimp, bluefin tuna, octopus, scallop, and mixed ceviche.',
  },
];

// Define the items for the hot (Caliente) column
const calienteItems = [
  {
    name: 'Camarones A La Cucaracha',
    price: '$22',
    description: 'Shrimp in our house deviled sauce.',
  },
  {
    name: 'Almeja La Bufadora',
    price: '$19',
    description:
      'Cooked clams, shrimp, melted cheese, and pico de gallo topped with chipotle mayo.',
  },
  { name: 'Pescado y Papas', price: '$17', description: 'Fish and fries.' },
  { name: 'Camaron y Papas', price: '$19', description: 'Shrimp and fries.' },
  { name: 'Combo', price: '$21', description: 'Fish, shrimp, and fries.' },
];

const BotanasSection: React.FC = () => {
  return (
    <section className="relative w-full bg-white py-12 px-4 lg:px-24 space-y-16">
      {/* Section Title */}
      <div className="mb-4 text-center">
        <h2 className="font-charles text-maroon text-5xl md:text-6xl">
          BOTANAS | APPETIZERS
        </h2>
      </div>

      {/* Prawn Border Image */}
      <div className="flex justify-center mb-8">
        <img
          src={prawnBorder}
          alt="Prawn Border"
          className="w-full max-w-4xl object-contain"
        />
      </div>

      {/* Two-column layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mx-auto max-w-4xl">
        {/* Left Column: FRÍO | COLD */}
        <div className="pr-4 border-r border-sea">
          <h3 className="font-charles text-sea text-3xl mb-4 text-center">
            FRÍO | COLD
          </h3>
          <ul className="space-y-4">
            {frioItems.map((item, idx) => (
              <li key={idx} className="font-prosto text-sea text-xl">
                <div className="flex justify-between">
                  <span>{item.name}</span>
                  <span className="font-bold">{item.price}</span>
                </div>
                {item.description && (
                  <p className="text-xs md:text-md max-w-xs text-sea/80 ml-2">
                    {item.description}
                  </p>
                )}
              </li>
            ))}
          </ul>
          {/* Sauce Options for mobile only */}
          <div className="block md:hidden">
            <SauceOptions />
          </div>
        </div>

        {/* Right Column: CALIENTE | HOT */}
        <div className="pl-4">
          {/* Shifted down by the crab image */}
          <div className="mb-4 flex justify-center">
            <img
              src={blueCrab}
              alt="Crab Accent"
              className="w-60 object-contain"
            />
          </div>
          <h3 className="font-charles text-maroon text-3xl mb-4 text-center">
            CALIENTE | HOT
          </h3>
          <ul className="space-y-4">
            {calienteItems.map((item, idx) => (
              <li key={idx} className="font-prosto text-sea text-xl">
                <div className="flex justify-between">
                  <span>{item.name}</span>
                  <span className="font-bold">{item.price}</span>
                </div>
                {item.description && (
                  <p className="text-xs md:text-md max-w-xs text-sea/80 ml-2">
                    {item.description}
                  </p>
                )}
              </li>
            ))}
          </ul>
          {/* Sauce Options for mobile only */}
          <div className="block md:hidden">
            <SauceOptions />
          </div>
        </div>
      </div>

      {/* For md+ screens, show a single centered Sauce Options below the grid */}
      <div className="hidden md:block mt-6">
        <SauceOptions />
      </div>
    </section>
  );
};

export default BotanasSection;
